import React, { useEffect, useState } from "react";
import { FileSpreadsheet } from "lucide-react";
import { ToastContainer, toast } from "react-toastify";
// import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import "react-toastify/dist/ReactToastify.css";
import XLSX from 'xlsx-js-style'

import { FaFileExcel } from "react-icons/fa";

const DrawingBoq = () => {
  const [drawings, setDrawings] = useState([]);
  const [loading, setLoading] = useState(true);


  const [showBoqForm, setShowBoqForm] = useState(false);
  const [selectedDrawing, setSelectedDrawing] = useState(null);
  
  const [boqItems, setBoqItems] = useState([]);
  const [loadingBoq, setLoadingBoq] = useState(false);
  const [boqErrors, setBoqErrors] = useState({});
  const [boqGeneratedMap, setBoqGeneratedMap] = useState({});
  const [selectedBoq, setSelectedBoq] = useState({});
  const [boqOptionsMap, setBoqOptionsMap] = useState({});
  const [loadingOptions, setLoadingOptions] = useState({});
  const [isSubmittingBoq, setIsSubmittingBoq] = useState(false);

  const fetchBoqOptions = async (boqMasterId) => {
    try {
      setLoadingOptions(prev => ({ ...prev, [boqMasterId]: true }));
  
      const res = await fetch(
        `${apiUrl}/api/boq/get_boq_options/${boqMasterId}`,
        {
          credentials: "include", 
        }
      );
  
      const data = await res.json();
  
      if (!res.ok || !data.success) {
        throw new Error();
      }
  
      setBoqOptionsMap(prev => ({
        ...prev,
        [boqMasterId]: data.options
      }));
  
    } catch (err) {
      toast.error("Failed to load options");
    } finally {
      setLoadingOptions(prev => ({ ...prev, [boqMasterId]: false }));
    }
  };


  const handleBoqMasterChange = (objectType, boqCode, boqMasterId) => {

    console.log({
      "masterId":boqMasterId,
      "boqCode":boqCode,
      "objectType":objectType

    });

    setSelectedBoq(prev => ({
      ...prev,
      [objectType]: {
        ...prev[objectType],
        [boqCode]: {
          masterId: boqMasterId,
          optionId: ""
        }
      }
    }));
  
    fetchBoqOptions(boqMasterId);
  };



  const handleBoqOptionChange = (objectType, boqCode, optionId) => {

    setSelectedBoq(prev => ({
      ...prev,
      [objectType]: {
        ...prev[objectType],
        [boqCode]: {
          ...prev[objectType][boqCode],
          optionId
        }
      }
    }));
  
  };
  
  const openBoqForm = (row) => {
    setSelectedDrawing(row);
    setShowBoqForm(true);
    fetchBoqItems();
  };
  
  
  const fetchBoqItems = async () => {
    try {
      setLoadingBoq(true);
      const res = await fetch(`${apiUrl}/api/boq/get_boq_items`, {
        credentials: "include",
      });
  
      const data = await res.json();
      if (!res.ok || !data.success) throw new Error();
  
      setBoqItems(data.boqItems || []);
    } catch (err) {
      toast.error("Failed to load BOQ items");
    } finally {
      setLoadingBoq(false);
    }
  };
  
  
  // const handleBoqChange = (objectType, boqCode, itemId) => {
  //   setSelectedBoq((prev) => ({
  //     ...prev,
  //     [objectType]: {
  //       ...prev[objectType],
  //       [boqCode]: itemId,
  //     },
  //   }));
  // };
  
  
  const handleBoqSubmit = async(e) => {
    e.preventDefault(); 
  
  
  
    let errors = {};
    let hasError = false;
  
    boqItems.forEach((obj) => {
      obj.boq_item_codes.forEach((boq) => {
        const selectedValue =
          selectedBoq?.[obj.object_type]?.[boq.boq_item_code];
  
        if (!selectedValue) {
          hasError = true;
  
          if (!errors[obj.object_type]) {
            errors[obj.object_type] = {};
          }
  
          errors[obj.object_type][boq.boq_item_code] = true;
        }
      });
    });
  
    setBoqErrors(errors);
  
    if (hasError) {
      toast.error("Please select all BOQ options");
      return;
    }
  
  
    const boqSelections = {};

    Object.values(selectedBoq).forEach(group => {
    
      Object.entries(group).forEach(([boqCode, value]) => {
    
        if (!value.masterId || !value.optionId) {
          toast.error("Please select all options");
          return;
        }
    
        boqSelections[boqCode] = {
          masterId: Number(value.masterId),
          optionId: Number(value.optionId)
        };
    
      });
    
    });
  
    const payload = {
      drawing_id: selectedDrawing._id,
      boq_selections: boqSelections
    };
  

    try {
  
      setIsSubmittingBoq(true)
      const res = await fetch(
        `${apiUrl}/api/boq/generate_boq`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${token}`,
          },
          credentials: "include",
          body: JSON.stringify(payload),
        }
      );
  
      const data = await res.json();
  
      if (!res.ok) {
        toast.warn(data.message || "Request failed");
        return; 
      }
      
      if (!data.success) {
        toast.warn(data.message || "BOQ generation failed");
        return;
      }
  
      toast.success("BOQ generated successfully");
      await fetchDrawings();
  
      console.log("API Response:", data);
  
      // optional
      setShowBoqForm(false);
    } catch (err) {
      console.error(err);
      toast.error("Failed to generate BOQ");
    }
    finally {
      setIsSubmittingBoq(false); 
    }
  
  };  

  const apiUrl = import.meta.env.VITE_API_URL;
  // const token = localStorage.getItem("token");

  useEffect(() => {
    fetchDrawings();
  }, []);

  const fetchDrawings = async () => {
    try {
      setLoading(true);
      const res = await fetch(
        `${apiUrl}/api/boq/finalized-drawings?limit=20`,
        {
          // headers: { Authorization: `Bearer ${token}` },
          credentials: "include",
        }
      );

      const data = await res.json();
      if (!res.ok) throw new Error(data.message);

      setDrawings(data.data || []);

      setDrawings(data.data || []);
      setBoqGeneratedMap(data.boqGeneratedMap || {});

    } catch (err) {
      toast.error("Failed to load drawings");
    } finally {
      setLoading(false);
    }
  };

  const exportExcel = async (row) => {
    try {
      toast.info("Generating Excel...");

      const res = await fetch(
        `${apiUrl}/api/boq/export_boq_excel/${row._id}`,
        {
          credentials: "include",
          // headers: {
          //   Authorization: `Bearer ${token}`,
          // },
        }
      );

      const data = await res.json();

      if (!res.ok || !data.success) {
        throw new Error("Export failed");
      }

      // 🔹 Excel-ready data
      const excelRows = data.rows.map((item) => ({
  
        BOQ_Description: item.boq_item_description,
        Item_Type_Name: item.item_type_name,
        Option_Name: item.option_name,
        Brand: item.brand,
        Rate: item.rate,
        Option_Unit: item.option_unit,
        Quantity: Number(item.quantity),
        Total_Amount: item.total_amount,      
        // Created_At: new Date(item.finalized_at).toLocaleString(),
      }));
      

const worksheet = XLSX.utils.aoa_to_sheet([]);

// 🔹 Header row (Row 2)
const headers = [

  "BOQ Description",
  "Item Type Name",
  "Option Name",
  "Brand",
  "Rate",
  "Unit",
  "Quantity",
  "Total Amount",
  // "Created At",
];

XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: "A2" });

XLSX.utils.sheet_add_json(worksheet, excelRows, { origin: "A3", skipHeader: true,
});

// 🔹 Style header row
headers.forEach((_, colIndex) => {
  const cellAddress = XLSX.utils.encode_cell({
    r: 1, // row index 1 = Excel row 2
    c: colIndex,
  });

  if (!worksheet[cellAddress]) return;

  worksheet[cellAddress].s = {
    font: { bold: true },
    fill: {
      fgColor: { rgb: "E9EEF3" }, // light grey-blue
    },
    alignment: {
      horizontal: "center",
      vertical: "center",
    },
    border: {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    },
  };
});


const borderStyle = {
  top: { style: "thin" },
  bottom: { style: "thin" },
  left: { style: "thin" },
  right: { style: "thin" },
};


const startRow = 2; // data starts at row index 2 (Excel row 3)
const totalRows = excelRows.length;
const totalCols = headers.length;

for (let r = startRow; r < startRow + totalRows; r++) {
  for (let c = 0; c < totalCols; c++) {
    const cellAddress = XLSX.utils.encode_cell({ r, c });

    if (!worksheet[cellAddress]) continue;

    worksheet[cellAddress].s = {
      ...worksheet[cellAddress].s,
      border: borderStyle,
      alignment: {
        vertical: "center",
      },
    };
  }
}


      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "BOQ");

      // 🔹 Download
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const file = new Blob([excelBuffer], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(file, `${row.drawing_name}_BOQ.xlsx`);

      toast.success("Excel downloaded successfully");
    } catch (error) {
      console.error(error);
      toast.error("Failed to export Excel");
    }
  };

  return (
    <div className="max-w-7xl mx-auto">
      <ToastContainer theme="dark" />

      <div className="mb-8">
        <h1 className="text-3xl font-bold text-white mb-2">
          Drawing BOQ
        </h1>
        <p className="text-gray-400">
          Finalized drawings with project & client details
        </p>
      </div>

      <div className="bg-gray-800/60 rounded-2xl border border-gray-700/50 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-900/80">
              <tr>
                <th className="px-6 py-4 text-left text-gray-300">
                  Drawing
                </th>
                <th className="px-6 py-4 text-left text-gray-300">
                  Project
                </th>
                <th className="px-6 py-4 text-left text-gray-300">
                  Client
                </th>
                <th className="px-6 py-4 text-right text-gray-300">
                  Export
                </th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="4" className="py-10 text-center text-gray-400">
                    Loading drawings...
                  </td>
                </tr>
              ) : drawings.length === 0 ? (
                <tr>
                  <td colSpan="4" className="py-10 text-center text-gray-400">
                    No finalized drawings found
                  </td>
                </tr>
              ) : (
                drawings.map((row) => (
                  <tr
                    key={row._id}
                    className="border-b border-gray-700/30 hover:bg-gray-700/40 transition"
                  >
                    <td className="px-6 py-4 text-white">
                      {row.drawing_name}
                    </td>
                    <td className="px-6 py-4 text-gray-300">
                      {row.project_id?.project_name}
                    </td>
                    <td className="px-6 py-4 text-gray-300">
                      {row.project_id?.client_name}
                    </td>
                    <td className="px-6 py-4 text-right flex justify-end gap-4">
                      <button
                        // onClick={() => exportExcel(row)}
                       onClick={() => openBoqForm(row)}
                      className="inline-flex items-center space-x-2 bg-green-600/80 hover:bg-green-700 px-4 py-2 rounded-lg text-white transition"
                      >
                        <span>Generate BOQ</span>
                      </button>
                     
                      {boqGeneratedMap[row._id] && (
                    <button
                      onClick={() => exportExcel(row)}
                      className="inline-flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 px-3 py-2 rounded-lg text-white transition"
                      title="Download Excel"
                    >
                      <FaFileExcel className="text-lg" />
                    </button>
                  )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          {showBoqForm && (
  <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
    <div className="bg-gray-900 rounded-xl w-full max-w-3xl p-6 border border-gray-700">
      
      <h2 className="text-xl font-semibold text-white mb-4">
        Generate BOQ
      </h2>

      <p className="text-gray-400 mb-4">
        Drawing: <span className="text-white">{selectedDrawing?.drawing_name}</span>
      </p>


      {loadingBoq ? (
  <p className="text-gray-400">Loading BOQ items...</p>
) : (
  <div className="space-y-6 max-h-[60vh] overflow-y-auto pr-2">

{boqItems.map((obj) => (
  <div key={obj.object_type}>

    <h3 className="text-lg font-semibold text-white mb-3">
      {obj.object_type}
    </h3>

    {obj.boq_item_codes.map((boq) => {

      const masterId =
        selectedBoq?.[obj.object_type]?.[boq.boq_item_code]?.masterId;

      const optionId =
        selectedBoq?.[obj.object_type]?.[boq.boq_item_code]?.optionId;

      const options = boqOptionsMap[masterId] || [];

      return (
        <div key={boq.boq_item_code} className="mb-4">

          {/* MASTER DROPDOWN */}
          <label className="block text-gray-300 mb-1">
            {boq.boq_item_description}
          </label>

          <select
            className="w-full mb-2 px-3 py-2 bg-gray-800 text-white border border-gray-600 rounded-lg"
            value={masterId || ""}
            onChange={(e) =>
              handleBoqMasterChange(
                obj.object_type,
                boq.boq_item_code,
                e.target.value
              )
            }
          >
            <option value="">Select Type</option>

            {boq.items.map((item) => (
              <option key={item.id} value={item.id}>
                {item.item_type_name}
              </option>
            ))}

          </select>


          {/* OPTIONS DROPDOWN */}
          {masterId && (
            <select
              className="w-full px-3 py-2 bg-gray-800 text-white border border-gray-600 rounded-lg"
              value={optionId || ""}
              onChange={(e) =>
                handleBoqOptionChange(
                  obj.object_type,
                  boq.boq_item_code,
                  e.target.value
                )
              }
            >
              <option value="">Select Option</option>

              {loadingOptions[masterId] ? (
                <option>Loading...</option>
              ) : (
                options.map(option => (
                  <option key={option.id} value={option.id}>
                    {option.option_name} - {option.brand} - ₹{option.rate}/{option.unit}
                  </option>
                ))
              )}

            </select>
          )}

        </div>
      );

    })}

  </div>
))}

  </div>
)}

      <form  onSubmit={handleBoqSubmit}>
        <div className="flex justify-end space-x-3 mt-6">
        <button
  type="button"
  disabled={isSubmittingBoq}
  onClick={() => setShowBoqForm(false)}
  className="px-4 py-2 rounded-lg bg-gray-700 text-white hover:bg-gray-600 disabled:opacity-50"
>
  Cancel
</button>

          <button
  type="submit"
  disabled={isSubmittingBoq}
  className="px-4 py-2 rounded-lg bg-green-600 text-white 
             hover:bg-green-700 
             disabled:opacity-50 disabled:cursor-not-allowed
             flex items-center gap-2 justify-center min-w-[120px]"
>
  {isSubmittingBoq ? (
    <>
      <svg
        className="animate-spin h-5 w-5"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
          className="opacity-25"
        />
        <path
          fill="currentColor"
          className="opacity-75"
          d="M4 12a8 8 0 018-8v8H4z"
        />
      </svg>

      Generating...
    </>
  ) : (
    "Generate"
  )}
</button>
        </div>
      </form>

    </div>
  </div>
)}


        </div>
      </div>
    </div>
  );
};

export default DrawingBoq;
